export default "__VITE_ASSET__BmTFgKI$__"